"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const CalorieCount_1 = require("./CalorieCount");
const typography_1 = require("../../shared/typography");
const translateDay = (daysTranslations, dayNumber) => daysTranslations[dayNumber];
const resolveText = (text, _method, dayType, trainingDayLabel) => {
    let label = text;
    if (dayType === "TRAINING") {
        label += ` - ${trainingDayLabel}`;
    }
    return label;
};
const renderCalorieCountDay = (props) => {
    return ((0, jsx_runtime_1.jsx)(CalorieCount_1.CalorieCount, { translations: props.translations, nutritionFacts: props.day.nutritionFacts, unit: props.unit || "", isPreview: true, dayType: props.day.dayType, calorieBudgetBundle: props.calorieBudgetBundle, hasCalorieBudget: !props.noCalorieBudget, calorieBudgetInfo: props.day.calorieBudgetInfo }, props.day.date));
};
const DayPreview = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: props.onClick, children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: resolveText(translateDay(props.translations.days, props.day.day), props.day.method, props.day.dayType, props.translations.trainingDayType) }, void 0), (0, jsx_runtime_1.jsx)("div", { "data-cy": "nutrition-week-item", children: ["caloriecount", "mixed"].includes(props.day.method) ? (renderCalorieCountDay(props)) : ((0, jsx_runtime_1.jsx)(typography_1.P, { children: props.translations.handpalmMethod }, void 0)) }, void 0)] }, void 0));
};
exports.DayPreview = DayPreview;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  h2,
  p {
    margin-bottom: 0;
    line-height: 1.5rem;
  }

  h2:first-of-type {
    text-transform: capitalize;
  }

  & > div {
    align-items: flex-start;
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    border-left: none;
    border-right: none;
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=DayPreview.js.map